export enum GTMErrorType {
  Account = 'Account',
  TagInstallation = 'TagInstallation',
}
